'use client';
import { GoogleTagManager } from '@next/third-parties/google';
import { useCounters } from '@/shared/hooks/useCounters';

const GtmInitializer = () => {
  const { counters } = useCounters();
  const gtmId = process.env.NEXT_PUBLIC_GTM_ID;

  if (!gtmId || !counters?.gtm) {
    return null;
  }

  return <GoogleTagManager gtmId={gtmId} />;
};

export { GtmInitializer };
